import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'functions/axios';
import * as Sentry from '@sentry/browser';


if(process.env.REACT_APP_TYPE === 'production') {
	Sentry.init({dsn: "https://022319e55f0c405fb6f48bc21bb9faee@sentry.io/1815570"});
}


// API

window.api = process.env.REACT_APP_API;
window.env = {
	cdn: process.env.REACT_APP_CDN
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
